import { vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "v3dp__input_wrapper" }
const _hoisted_2 = ["id", "readonly", "placeholder", "disabled", "tabindex"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, null, -1)
const _hoisted_5 = { class: "v3dp__clearable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_year_picker = _resolveComponent("year-picker")!
  const _component_month_picker = _resolveComponent("month-picker")!
  const _component_day_picker = _resolveComponent("day-picker")!
  const _component_time_picker = _resolveComponent("time-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: "v3dp__datepicker",
    style: _normalizeStyle(_ctx.variables(_ctx.$attrs.style))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.compact ? 'form' : 'form-floating')
      }, [
        _withDirectives(_createElementVNode("input", _mergeProps({
          type: "text",
          ref: "inputRef",
          class: "form-control",
          id: _ctx.id,
          readonly: !_ctx.typeable,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event))
        }, _ctx.$attrs, {
          placeholder: _ctx.placeholder,
          disabled: _ctx.disabled,
          tabindex: _ctx.disabled ? -1 : 0,
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.keyUp && _ctx.keyUp(...args))),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.renderView())),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.renderView(_ctx.initialView))),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.renderView(_ctx.initialView)))
        }), null, 16, _hoisted_2), [
          [_vModelText, _ctx.input]
        ]),
        (_ctx.showLabel)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: _ctx.id,
              class: "form-label"
            }, _toDisplayString(_ctx.label), 9, _hoisted_3))
          : _createCommentVNode("", true),
        _hoisted_4
      ], 2),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "clear", { onClear: _ctx.clearModelValue }, () => [
          _createElementVNode("i", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearModelValue()))
          }, "x")
        ])
      ], 512), [
        [_vShow, _ctx.clearable && _ctx.modelValue]
      ])
    ]),
    _withDirectives(_createVNode(_component_year_picker, {
      pageDate: _ctx.pageDate,
      "onUpdate:pageDate": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageDate) = $event)),
      selected: _ctx.modelValue,
      lowerLimit: _ctx.lowerLimit,
      upperLimit: _ctx.upperLimit,
      onSelect: _ctx.selectYear
    }, null, 8, ["pageDate", "selected", "lowerLimit", "upperLimit", "onSelect"]), [
      [_vShow, _ctx.viewShown === 'year']
    ]),
    _withDirectives(_createVNode(_component_month_picker, {
      pageDate: _ctx.pageDate,
      "onUpdate:pageDate": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageDate) = $event)),
      selected: _ctx.modelValue,
      onSelect: _ctx.selectMonth,
      lowerLimit: _ctx.lowerLimit,
      upperLimit: _ctx.upperLimit,
      format: _ctx.monthListFormat,
      headingFormat: _ctx.monthHeadingFormat,
      locale: _ctx.locale,
      onBack: _cache[8] || (_cache[8] = ($event: any) => (_ctx.viewShown = 'year'))
    }, null, 8, ["pageDate", "selected", "onSelect", "lowerLimit", "upperLimit", "format", "headingFormat", "locale"]), [
      [_vShow, _ctx.viewShown === 'month']
    ]),
    _withDirectives(_createVNode(_component_day_picker, {
      pageDate: _ctx.pageDate,
      "onUpdate:pageDate": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageDate) = $event)),
      selected: _ctx.modelValue,
      weekStartsOn: _ctx.weekStartsOn,
      lowerLimit: _ctx.lowerLimit,
      upperLimit: _ctx.upperLimit,
      disabledDates: _ctx.disabledDates,
      locale: _ctx.locale,
      weekdayFormat: _ctx.weekdayFormat,
      onSelect: _ctx.selectDay,
      onBack: _cache[10] || (_cache[10] = ($event: any) => (_ctx.viewShown = 'month'))
    }, null, 8, ["pageDate", "selected", "weekStartsOn", "lowerLimit", "upperLimit", "disabledDates", "locale", "weekdayFormat", "onSelect"]), [
      [_vShow, _ctx.viewShown === 'day']
    ]),
    _withDirectives(_createVNode(_component_time_picker, {
      pageDate: _ctx.pageDate,
      "onUpdate:pageDate": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pageDate) = $event)),
      visible: _ctx.viewShown === 'time',
      selected: _ctx.modelValue,
      disabledTime: _ctx.disabledTime,
      onSelect: _ctx.selectTime,
      onBack: _cache[12] || (_cache[12] = () => (_ctx.startingView === 'time' && _ctx.minimumView === 'time') ? null : _ctx.viewShown = 'day')
    }, null, 8, ["pageDate", "visible", "selected", "disabledTime", "onSelect"]), [
      [_vShow, _ctx.viewShown === 'time']
    ])
  ], 4))
}